import axios from 'axios';
import jwtDecode from 'jwt-decode';
import mbpUtil from 'mbp-api-util';
import UAParser from 'ua-parser-js';
import Cookies from 'universal-cookie';
import React, { PureComponent } from 'react';
import { object, string, func, bool } from 'prop-types';
import { Link } from 'react-router-dom';
import Modal from '@material-ui/core/Modal';
import CloseIcon from '@material-ui/icons/Clear';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

function getWindow() {
  if (typeof window === 'undefined') {
    return null;
  }
  return window;
}
function _typeof$5(o) {
  "@babel/helpers - typeof";

  return _typeof$5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$5(o);
}
function _createClass$4(e, r, t) {
  return Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _classCallCheck$4(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperty$4(e, r, t) {
  return (r = _toPropertyKey$5(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey$5(t) {
  var i = _toPrimitive$5(t, "string");
  return "symbol" == _typeof$5(i) ? i : i + "";
}
function _toPrimitive$5(t, r) {
  if ("object" != _typeof$5(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof$5(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var UserAgentParser = /*#__PURE__*/_createClass$4(function UserAgentParser(_ref) {
  var _this = this;
  var windowInterface = _ref.windowInterface,
    UAParserInterface = _ref.UAParserInterface;
  _classCallCheck$4(this, UserAgentParser);
  _defineProperty$4(this, "buildString", function (pieces) {
    var output = '';
    if (!pieces.length) {
      return output;
    }
    pieces.forEach(function (piece) {
      if (!piece) {
        return;
      }
      if (!output.length) {
        output = piece;
      } else {
        output = "".concat(output, " ").concat(piece);
      }
    });
    return output;
  });
  _defineProperty$4(this, "getUAParser", function (requestUserAgentString) {
    var isSSR = _this.window === null;
    if (isSSR && requestUserAgentString) {
      return new _this.UAParser(requestUserAgentString);
    } else if (!isSSR) {
      return new _this.UAParser();
    }
    return null;
  });
  _defineProperty$4(this, "parse", function (requestUserAgentString) {
    var parser = _this.getUAParser(requestUserAgentString);

    // if on server and facet requestUserAgentString not passed,
    // return empty object
    if (!parser) {
      return {};
    }
    var ua = parser.getResult();

    // convert to top level strings for output in logger
    var output = {
      ua: ua.ua,
      browser: _this.buildString([ua.browser.name, ua.browser.version]),
      engine: _this.buildString([ua.engine.name, ua.engine.version]),
      os: _this.buildString([ua.os.name, ua.os.version]),
      device: _this.buildString([ua.device.model, ua.device.type, ua.device.vendor])
    };
    return output;
  });
  this.window = windowInterface;
  this.UAParser = UAParserInterface;
});
var window$4 = getWindow();
var userAgentParser = new UserAgentParser({
  windowInterface: window$4,
  UAParserInterface: UAParser
});
function _typeof$4(o) {
  "@babel/helpers - typeof";

  return _typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$4(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) ;else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _createClass$3(e, r, t) {
  return Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _classCallCheck$3(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperty$3(e, r, t) {
  return (r = _toPropertyKey$4(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey$4(t) {
  var i = _toPrimitive$4(t, "string");
  return "symbol" == _typeof$4(i) ? i : i + "";
}
function _toPrimitive$4(t, r) {
  if ("object" != _typeof$4(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof$4(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var UrlParser = /*#__PURE__*/_createClass$3(function UrlParser(_ref) {
  var _this = this;
  var windowInterface = _ref.windowInterface;
  _classCallCheck$3(this, UrlParser);
  _defineProperty$3(this, "mapIteratorToPlainObj", function (iterator) {
    var output = {};
    if (!(Symbol.iterator in Object(iterator))) {
      return {};
    }
    if (typeof iterator === 'string' && iterator.length) {
      var tuples = iterator.slice(1, iterator.length).split('&');
      tuples.forEach(function (tuple) {
        var _tuple$split = tuple.split('='),
          _tuple$split2 = _slicedToArray(_tuple$split, 2),
          key = _tuple$split2[0],
          val = _tuple$split2[1];
        output[key.trim()] = val.trim();
      });
      return output;
    }

    // eslint-disable-next-line no-restricted-syntax
    var _iterator = _createForOfIteratorHelper(iterator),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          value = _step$value[1];
        output[key] = value;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return output;
  });
  _defineProperty$3(this, "isValid", function (url) {
    if (typeof url !== 'string') {
      return false;
    }
    var lowercase = url.toLowerCase();
    if (lowercase === 'undefined' || lowercase === 'null') {
      return false;
    }
    return true;
  });
  /**
   *
   * @param {string} url
   * @returns { object }
   * @example {
   *    error: boolean,
   *    url: string,
   *    host?: string,
   *    path?: string,
   *    queryString?: string,
   * }
   */
  _defineProperty$3(this, "parse", function (url) {
    var isSSR = _this.window === null;
    var reconciledUrl;
    if (isSSR && url) {
      reconciledUrl = url;
    } else if (!isSSR) {
      reconciledUrl = _this.window.location.href;
    }
    if (!_this.isValid(reconciledUrl)) {
      return {
        error: true,
        url: String(reconciledUrl)
      };
    }
    var parser;
    try {
      parser = new URL(reconciledUrl);
    } catch (err) {
      return {
        error: true,
        url: reconciledUrl
      };
    }
    var queryString = _this.mapIteratorToPlainObj(parser.searchParams || parser.search);
    return {
      error: false,
      url: reconciledUrl,
      host: parser.host,
      path: parser.pathname,
      queryString: queryString
    };
  });
  this.window = windowInterface;
});
var window$3 = getWindow();
var urlParser = new UrlParser({
  windowInterface: window$3
});

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var cookies = new Cookies();

/**
 * @description Get a single or multiple cookies by value.
 * @argument {string|[string]} name - The name of the cookie.
 * @returns {string|[string]}
 */

function getCookieByName(name) {
  if (!name) {
    return 'cookie looked up with no name';
  }
  if (typeof name === 'string') {
    return cookies.get(name) || 'cookie not found';
  }
  if (Array.isArray(name)) {
    var output = [];
    name.forEach(function (n) {
      output.push(cookies.get(n) || 'cookie not found');
    });
    return output;
  }
  return "".concat(name, " cookie not found");
}
function _typeof$3(o) {
  "@babel/helpers - typeof";

  return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$3(o);
}
function _classCallCheck$2(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey$3(o.key), o);
  }
}
function _createClass$2(e, r, t) {
  return r && _defineProperties$1(e.prototype, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey$3(t) {
  var i = _toPrimitive$3(t, "string");
  return "symbol" == _typeof$3(i) ? i : i + "";
}
function _toPrimitive$3(t, r) {
  if ("object" != _typeof$3(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof$3(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var LocalStorage = /*#__PURE__*/function () {
  function LocalStorage(_ref) {
    var windowInterface = _ref.windowInterface;
    _classCallCheck$2(this, LocalStorage);
    this.localStorage = null;

    // dependency injection
    if (windowInterface && windowInterface.localStorage) {
      this.localStorage = windowInterface.localStorage;
    }
  }
  return _createClass$2(LocalStorage, [{
    key: "get",
    value: function get(key) {
      if (!this.localStorage) {
        return null;
      }
      var val = this.localStorage.getItem(key);
      return val;
    }
  }]);
}();
var window$2 = getWindow();
var localStorage = new LocalStorage({
  windowInterface: window$2
});
var _excluded = ["message", "error", "jsError", "errorMessage", "stack", "severity", "requestUrl", "requestUserAgentString"];
function _typeof$2(o) {
  "@babel/helpers - typeof";

  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$2(o);
}
function ownKeys$1(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$1(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) {
      _defineProperty$2(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _createClass$1(e, r, t) {
  return Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _classCallCheck$1(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperty$2(e, r, t) {
  return (r = _toPropertyKey$2(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey$2(t) {
  var i = _toPrimitive$2(t, "string");
  return "symbol" == _typeof$2(i) ? i : i + "";
}
function _toPrimitive$2(t, r) {
  if ("object" != _typeof$2(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof$2(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var window$1 = getWindow();
var PayloadBuilder = /*#__PURE__*/_createClass$1(function PayloadBuilder(_ref) {
  var _this = this;
  var windowInterface = _ref.windowInterface,
    localStorageInterface = _ref.localStorageInterface,
    urlParserInterface = _ref.urlParserInterface,
    userAgentParserInterface = _ref.userAgentParserInterface;
  _classCallCheck$1(this, PayloadBuilder);
  _defineProperty$2(this, "fromParamObj", function (paramObj) {
    if (!paramObj) {
      return {
        message: 'no logging information provided'
      };
    }

    // Destructure message param to exclude from console log params
    var message = paramObj.message;
    paramObj.error;
    paramObj.jsError;
    var errorMessage = paramObj.errorMessage,
      stack = paramObj.stack,
      severity = paramObj.severity,
      requestUrl = paramObj.requestUrl,
      requestUserAgentString = paramObj.requestUserAgentString,
      consoleLogParams = _objectWithoutProperties(paramObj, _excluded);

    // TODO add ga id

    var userAgent = _this.userAgentParser.parse(requestUserAgentString);
    var url = _this.urlParser.parse(requestUrl);

    // cookies
    var shopperManager = getCookieByName('ShopperManagerEnterprise');

    // pageType
    var _ref2 = _this.window || {},
      pageType = _ref2.pageType;

    // localstorage
    // localstorage returns null for bad vals, default to undefined
    var enterpriseId = _this.localStorage.get('enterpriseId') || undefined;
    var payload = _objectSpread$1(_objectSpread$1({}, consoleLogParams), {}, {
      app: _this.appName,
      severity: severity,
      message: "mbpLogger ".concat(message),
      error: {
        kind: severity,
        message: errorMessage,
        stack: stack
      },
      source: _this.appSource,
      enterpriseId: enterpriseId,
      shopperManager: shopperManager,
      http: {
        url: url.url || undefined,
        url_details: {
          host: url.host || undefined,
          path: url.path || undefined,
          queryString: url.queryString || undefined
        },
        useragent: userAgent.ua || undefined,
        useragent_details: {
          os: {
            family: userAgent.os || undefined
          },
          browser: {
            family: userAgent.browser || undefined
          },
          device: {
            family: userAgent.device || undefined
          }
        }
      },
      pageType: pageType
    });
    return payload;
  });
  this.localStorage = localStorageInterface;
  this.urlParser = urlParserInterface;
  this.userAgentParser = userAgentParserInterface;
  this.window = windowInterface;
  this.appName = this.window ? 'mbp-pwa-client' : 'mbp-pwa-node';
  this.appSource = this.window ? 'browser' : 'node';
});
var payloadBuilder = new PayloadBuilder({
  windowInterface: window$1,
  localStorageInterface: localStorage,
  urlParserInterface: urlParser,
  userAgentParserInterface: userAgentParser
});

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var getLoggingServiceEndpointURL = function getLoggingServiceEndpointURL() {
  var isSSR = typeof window === 'undefined';
  var protocol;
  if (isSSR) {
    protocol = process.env.APP_WC_PROTOCOL_SSR || 'http';
  } else {
    protocol = mbpUtil.getEnv('APP_WC_PROTOCOL') || 'https';
  }
  var host;
  if (isSSR) {
    host = 'mbp-logger-splunk.common-services.svc.cluster.local:8080';
  } else {
    host = mbpUtil.getEnv('REACT_APP_MBP_LOGGER_HOST') || window.location.hostname;
  }
  var path;
  if (isSSR) {
    path = 'logging/mbp-ui';
  } else {
    path = 'r/api/logging/mbp-ui';
  }
  var url = "".concat(protocol, "://").concat(host, "/").concat(path);
  return url;
};
function _typeof$1(o) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$1(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey$1(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof$1(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _defineProperty$1(e, r, t) {
  return (r = _toPropertyKey$1(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey$1(t) {
  var i = _toPrimitive$1(t, "string");
  return "symbol" == _typeof$1(i) ? i : i + "";
}
function _toPrimitive$1(t, r) {
  if ("object" != _typeof$1(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof$1(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var styles = function styles(theme) {
  return {
    modalContent: {
      position: 'absolute',
      width: '80%',
      backgroundColor: theme.palette.white,
      boxShadow: theme.shadows[5],
      padding: 0,
      // theme.spacing.unit * 2,
      textAlign: 'center',
      borderRadius: '8px',
      '&:focus': {
        outline: "solid 0px ".concat(theme.cta1),
        boxShadow: "0 0 10px ".concat(theme.cta1)
      }
    },
    descModal: {
      color: theme.cta1,
      marginTop: '0px'
    },
    closeIconButton: {
      position: 'absolute',
      right: '-10px',
      top: '-10px',
      padding: '2px'
    },
    closeIcon: {
      backgroundColor: theme.cta1,
      borderRadius: '100%',
      color: theme.palette.white,
      fontSize: '24px',
      padding: '1px'
    },
    titleH2: {
      backgroundColor: theme.cta1,
      color: theme.palette.white,
      margin: '0',
      padding: '6px 10px',
      fontSize: '16px',
      fontWeight: '400',
      borderRadius: '8px 8px 0 0'
    },
    info: {
      margin: '5px 0 0',
      padding: '10px',
      textAlign: 'justify'
    },
    infoHome: {
      padding: '5px 10px'
    },
    linkHome: {
      color: theme.brown1,
      margin: '0 4px'
    }
  };
};
function getModalStyle() {
  var top = 50;
  var left = 50;
  return {
    top: "".concat(top, "%"),
    left: "".concat(left, "%"),
    transform: "translate(-".concat(top, "%, -").concat(left, "%)")
  };
}
var ErrorModal = /*#__PURE__*/function (_PureComponent) {
  function ErrorModal() {
    var _this;
    _classCallCheck(this, ErrorModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ErrorModal, [].concat(args));
    _defineProperty$1(_this, "getErrorMessage", function (errorKey, brandCode, classes) {
      var errorMessage = '';
      var showHomeLink = false;
      switch (errorKey) {
        case '_ERR_PROD_NOT_EXISTING':
          errorMessage = 'We are sorry, but this product is no longer available. Please select another product.';
          showHomeLink = true;
          break;
        case '_ERR_PRODUCT_OUT_OF_STOCK':
          errorMessage = 'We are sorry, but this product is currently out of stock. Please select another product.';
          showHomeLink = true;
          break;
        case '_ERR_PASSPORT_ITEM_ALREADY_IN_CART':
          errorMessage = 'Your cart already contains a passport membership.';
          break;
        default:
          errorMessage = 'There was an unexpected problem.';
          break;
      }
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
        className: classes.titleH2
      }, "Information"), /*#__PURE__*/React.createElement("p", {
        className: classes.info
      }, errorMessage), showHomeLink && /*#__PURE__*/React.createElement("p", {
        className: classes.infoHome
      }, "Click", /*#__PURE__*/React.createElement(Link, {
        className: classes.linkHome,
        to: "/".concat(brandCode, "-HomePage")
      }, "here"), "to return to our Home page."));
    });
    return _this;
  }
  _inherits(ErrorModal, _PureComponent);
  return _createClass(ErrorModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        errorMessage = _this$props.errorMessage,
        brandCode = _this$props.brandCode,
        clickCloseModal = _this$props.clickCloseModal,
        isOpenModal = _this$props.isOpenModal;
      return /*#__PURE__*/React.createElement(Modal, {
        "aria-labelledby": "simple-modal-title",
        "aria-describedby": "simple-modal-description",
        open: isOpenModal,
        onClose: clickCloseModal
      }, /*#__PURE__*/React.createElement("div", {
        style: getModalStyle(),
        className: classes.modalContent
      }, /*#__PURE__*/React.createElement(IconButton, {
        classes: {
          root: classes.closeIconButton
        },
        "aria-label": "Close",
        onClick: clickCloseModal
      }, /*#__PURE__*/React.createElement(CloseIcon, {
        className: classes.closeIcon,
        style: {
          maxWidth: '24px'
        }
      })), /*#__PURE__*/React.createElement("div", {
        id: "modal-description",
        className: classes.descModal
      }, errorMessage && errorMessage.errorKey && this.getErrorMessage(errorMessage.errorKey, brandCode, classes))));
    }
  }]);
}(PureComponent);
ErrorModal.propTypes = {
  classes: object.isRequired,
  // added by withStyles HOC
  errorMessage: object,
  brandCode: string,
  clickCloseModal: func.isRequired,
  isOpenModal: bool.isRequired
};
ErrorModal.defaultProps = {
  errorMessage: {},
  // errorKey: _ERR_PRODUCT_OUT_OF_STOCK - _ERR_PROD_NOT_EXISTING - _ERR_PASSPORT_ITEM_ALREADY_IN_CART
  brandCode: ''
};
var ErrorModal$1 = withStyles(styles)(ErrorModal);
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var severities = ['DEBUG', 'INFO', 'WARN', 'ERROR', 'NONE'];

// const stackLimit = mbpUtil.getEnv('REACT_APP_MBP_LOGGER_STACKLIMIT') || 5;   // number of stack elements saved for error
var maxString = mbpUtil.getEnv('REACT_APP_MBP_LOGGER_MAXSTRING') || 256;
var loggingServiceEnabled = mbpUtil.getEnv('APP_LOGGING_ENABLED') || 'true';

// Threshold for console logging.
// When you want all messages logged to console, set to 'DEBUG' -- usual case for development
// When you want no messages logged to console, set to 'NONE' -- usual case for production
// When set to 'ERROR', only logs with 'ERROR' severity shown on console - no WARN, INFO or DEBUG
var consoleLoggingThreshold = mbpUtil.getEnv('REACT_APP_MBP_LOGGER_CONSOLE') || 'NONE';

//
// Internal functions
//
// (some of these are exported, but only for benefit of unit tests.  Do not use.)

// Returns true if given severity is at or under given threshold
// E.g. returns True if threshold is 'INFO' and severity is 'INFO', 'WARN' or 'ERROR'
//      returns False for everything if threshold is 'NONE' (or not a valid severity)
function severityWithinThreshold(severityParam, severityThresholdParam) {
  var severity = severityParam.toUpperCase();
  var thresholdIndex = severities.indexOf(severityThresholdParam.toUpperCase());
  return thresholdIndex >= 0 && severities.indexOf(severity) >= thresholdIndex && severity !== 'NONE';
}
function capitalize(s) {
  return s.charAt(0).toUpperCase() + s.substr(1);
}

// if a[x] is present, set b[y] = a[x]   (if y omitted, set b[x] = a[x])
function assignIfPresent(sourceObj, sourceAttrib, targetObj) {
  var targetAttrib = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  if (sourceObj[sourceAttrib]) {
    targetObj[targetAttrib || sourceAttrib] = sourceObj[sourceAttrib]; // eslint-disable-line no-param-reassign
  }
}

// Do any cleanup necessary for splunk keys.
function keyCleanup(k) {
  return k.trim().replace(/\s+/g, '_'); // replace any whitespace with an _
}

// Unpack parameter object into a "flat" object of key-value pairs
function unpackParamObj(paramObj) {
  var UNDEFINED_STRING = 'undefined';
  var NULL_STRING = 'null';
  var payload = {};
  Object.keys(paramObj).forEach(function (attrib) {
    if (paramObj[attrib] === undefined) {
      payload[attrib] = UNDEFINED_STRING;
    } else if (paramObj[attrib] === null) {
      payload[attrib] = NULL_STRING;
    } else {
      switch (attrib) {
        case 'jsError':
          // javascript Error object
          ['name', 'message', 'description', 'fileName', 'lineNumber'].forEach(function (jsErrorAttrib) {
            assignIfPresent(paramObj.jsError, jsErrorAttrib, payload, "jsError".concat(capitalize(jsErrorAttrib)));
          });

          // TODO figure out how to get stack into DD https://docs.datadoghq.com/logs/log_collection/?tab=host#attributes-and-tags
          if (paramObj.jsError.stack) {
            var stack = paramObj.jsError.stack;
            payload.errorMessage = paramObj.jsError.message || 'no error message';
            payload.stack = stack.split(/[\r\n]+/).slice(1, 8).map(function (item) {
              return item.trim();
            }).join(', ');
          }
          break;
        case 'reactErrorInfo':
          // errorInfo object from React error boundary
          if (paramObj.reactErrorInfo.componentStack) {
            payload.errorMessage = paramObj.reactErrorInfo.message;
            payload.stack = paramObj.reactErrorInfo.componentStack.split(/[\r\n]+/).slice(1, 8).map(function (item) {
              return item.trim();
            }).join(', ');
          }
          break;
        case 'error':
          if (paramObj.error.stack) {
            var _paramObj$error = paramObj.error,
              _stack = _paramObj$error.stack,
              message = _paramObj$error.message;
            payload.errorMessage = message;
            payload.stack = _stack.split(/[\r\n]+/).slice(1, 8).map(function (item) {
              return item.trim();
            }).join(', ');
          }
          break;
        default:
          if (_typeof(paramObj[attrib]) === 'object') {
            if (Array.isArray(paramObj[attrib])) {
              paramObj[attrib].forEach(function (item, index) {
                var key = keyCleanup("".concat(attrib).concat(index));
                if (item === null) {
                  payload[key] = NULL_STRING;
                } else if (item === undefined) {
                  payload[key] = UNDEFINED_STRING;
                } else {
                  payload[key] = item.toString().trim().substr(0, maxString);
                }
              });
            } else {
              Object.keys(paramObj[attrib]).forEach(function (key) {
                var payloadKey = keyCleanup("".concat(attrib, " ").concat(key));
                if (paramObj[attrib][key] === null) {
                  payload[payloadKey] = NULL_STRING;
                } else if (paramObj[attrib][key] === undefined) {
                  payload[payloadKey] = UNDEFINED_STRING;
                } else {
                  payload[payloadKey] = paramObj[attrib][key].toString().trim().substr(0, maxString);
                }
              });
            }
          } else {
            payload[attrib] = paramObj[attrib].toString().trim().substr(0, maxString);
          }
      }
    }
  });
  return payload;
}
function mbpLog(keyValuePairObj) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var endpoint = getLoggingServiceEndpointURL();

  // dont make api calls from dev env
  if (endpoint.includes('localhost')) {
    return;
  }
  var logEntryProps = _objectSpread({}, keyValuePairObj);
  if (loggingServiceEnabled && loggingServiceEnabled === 'true') {
    axios.post(getLoggingServiceEndpointURL(), logEntryProps, {
      // TODO does this need to be called more than a single time per process?
      headers: {
        Authorization: "Bearer ".concat(token)
      }
    })["catch"](function (error) {
      if (severityWithinThreshold('ERROR', consoleLoggingThreshold)) {
        console.error(JSON.stringify({
          message: 'mbplogger: axios post failed',
          error: error
        }));
      }
    });
  }
}

// TODO rather than ignore in tests, convert to setting test env to silent severity
function sendToStdout(severity, payload) {
  if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
    return;
  }
  var stdoutFunction = console.error;
  if (severity === 'WARN') {
    stdoutFunction = console.warn;
  } else if (severity === 'INFO' || severity === 'DEBUG') {
    stdoutFunction = console.info;
  }
  if (typeof window === 'undefined') {
    stdoutFunction(JSON.stringify(payload));
  } else {
    stdoutFunction(payload);
  }
}

// TODO convert to class for injection and testing
function mbpLogWithSeverity(severity, paramObj) {
  var token = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var debugging = global.mbp && global.mbp.ssrConfig && global.mbp.ssrConfig.debugging ? global.mbp.ssrConfig.debugging : 'false';
  if (severityWithinThreshold(severity, consoleLoggingThreshold) || debugging && debugging !== 'false') {
    var JWT_PAYLOAD_KEY_1 = 'https://800-flowers.net';
    var JWT_PAYLOAD_KEY_2 = 'https://1800flowers.com/';
    var newParamObj = unpackParamObj(paramObj);
    newParamObj.severity = severity;
    newParamObj.time = new Date().getTime() / 1000.0; // fractional seconds since epoch

    var jwt = token;
    var decodedToken = null;
    var jwtContactId = 'NO_CONTACT_ID';
    if (!jwt) {
      var raw = localStorage.get('userInfo');
      var data = JSON.parse(raw);
      if (data && data.token) {
        jwt = data.token;
        decodedToken = jwtDecode(jwt);
      }
    }
    if (decodedToken) {
      var jwtPayload = decodedToken[JWT_PAYLOAD_KEY_1] || decodedToken[JWT_PAYLOAD_KEY_2];
      jwtContactId = jwtPayload.contactId || 'NO_CONTACT_ID';
      newParamObj.contactId = jwtContactId;
    }
    if (debugging && debugging !== 'false') {
      newParamObj.uuid = debugging;
    }
    var payload = payloadBuilder.fromParamObj(newParamObj);
    sendToStdout === null || sendToStdout === void 0 || sendToStdout(severity, payload);
    if (paramObj.UNIT_TEST) {
      return payload;
    }
    var gaCookie = getCookieByName('_ga');
    var shopperManager = getCookieByName('ShopperManagerEnterprise');
    return mbpLog(_objectSpread(_objectSpread({}, payload), {}, {
      contactId: jwtContactId,
      gaCookie: gaCookie,
      // TODO: this is a duplicate, see buildLogginPayload
      shopperManager: shopperManager
    }), jwt);
  }
  return null;
}
function logInfo(paramObj) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  mbpLogWithSeverity('INFO', paramObj, token);
}
function logError(paramObj) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  mbpLogWithSeverity('ERROR', paramObj, token);
}
function logWarning(paramObj) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  mbpLogWithSeverity('WARN', paramObj, token);
}
function logDebug(paramObj) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  mbpLogWithSeverity('DEBUG', paramObj, token);
}

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var logger = function logger(store) {
  return function (next) {
    return function (action) {
      var result = next(action);
      logDebug({
        action: action,
        'next-state': store.getState(),
        message: "REDUX: Dispatching Action: ".concat(action.type)
      });
      return result;
    };
  };
};
var crashReporter = function crashReporter(store) {
  return function (next) {
    return function (action) {
      try {
        return next(action);
      } catch (err) {
        logError({
          action: action,
          state: store.getState(),
          "function": 'crashReporter',
          module: 'mbp-logger',
          jsError: err,
          message: 'Redux error'
        });
        throw err;
      }
    };
  };
};
var middlewareLogger = {
  logger: logger,
  crashReporter: crashReporter
};

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var index = {
  logInfo: logInfo,
  logError: logError,
  logWarning: logWarning,
  logDebug: logDebug,
  ErrorModal: ErrorModal$1,
  middlewareLogger: middlewareLogger
};
export { index as default };